// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rUJb","colBig":"styles_colBig__3yfUk","colSmall":"styles_colSmall__1eF3_","shopifyNameWrapper":"styles_shopifyNameWrapper__3yo1h"};